import React, { Dispatch, SetStateAction } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { Avatar, FormControl, Typography, useTheme } from '@material-ui/core';
import Input from '../../../components/Forms/Input';
import { Formik, FormikState } from 'formik';
import { PasswordRegex } from '../../../constants';
import { Color } from '@material-ui/lab/Alert';
import * as Yup from 'yup';

const ChangePasswordModal = (props: {
   open: boolean;
   setOpen: Dispatch<SetStateAction<boolean>>;
   handleSubmit: (
      values: Record<string, any>,
      setSubmitting: (isSubmitting: boolean) => void,
      resetForm: (nextState?: Partial<FormikState<any>> | undefined) => void,
   ) => void;
   userfirstname: string;
   userlastname: string;
   username: string;
   userRole: string;
   userAccountType: string;
   userId: string;
   resetPassword: boolean;
   setAlertColor?: Dispatch<SetStateAction<Color | undefined>>;
   setAlertMessage?: Dispatch<SetStateAction<string>>;
   setShowAlert?: Dispatch<SetStateAction<boolean>>;
}) => {
   const theme = useTheme();
   const initialValues = props.resetPassword
      ? {
           id: props.userId,
           currentPassword: '',
           newPassword: '',
           confirmPassword: '',
        }
      : {
           id: props.userId,
           newPassword: '',
           confirmPassword: '',
        };
   return (
      <div>
         <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
               newPassword: Yup.string()
                  .matches(
                     PasswordRegex,
                     'Password must have Upper Case, Lower Case, Number and Special characters !@#$%^&*()-',
                  )
                  .required('Please provide the new password'),
               confirmPassword: Yup.string()
                  .required('Please confirm the user new password')
                  .oneOf([Yup.ref('newPassword'), ''], 'Passwords do not match'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => props.handleSubmit(values, setSubmitting, resetForm)}
         >
            {({ values, errors, touched, handleReset, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
               return (
                  <Dialog
                     maxWidth="sm"
                     open={props.open}
                     aria-labelledby="form-dialog-title"
                     style={{ padding: '0px' }}
                  >
                     <form autoComplete="off">
                        <input type="text" autoComplete="off" name="Username" style={{ display: 'none' }} />
                        <DialogTitle id="form-dialog-title">
                           <div
                              style={{
                                 display: 'flex',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 color: '#000',
                                 fontSize: '1rem',
                                 fontWeight: 600,
                              }}
                           >
                              <Typography variant="inherit">Change User&apos;s Password?</Typography>
                              <div
                                 onClick={() => props.setOpen(false)}
                                 onKeyDown={() => props.setOpen(false)}
                                 role="button"
                                 tabIndex={0}
                              >
                                 <CloseIcon />
                              </div>
                           </div>
                        </DialogTitle>
                        <DialogContent style={{ padding: '0px', width: '300px' }}>
                           <div
                              style={{
                                 backgroundColor: theme.palette.text.disabled,
                                 padding: '10px',
                                 marginBottom: '10px',
                                 display: 'flex',
                              }}
                           >
                              <Avatar />
                              <div style={{ margin: '0px 10px', color: '#000' }}>
                                 <Typography>
                                    <span style={{ fontWeight: 550, marginRight: '3px' }}>
                                       {props.userfirstname}, {props.userlastname}
                                    </span>{' '}
                                    <span style={{ fontStyle: 'italic', fontSize: '10px' }}>{props.username}</span>
                                 </Typography>
                                 <Typography style={{ fontSize: '11px' }}>{props.userAccountType}</Typography>
                              </div>
                           </div>

                           {props.resetPassword && (
                              <FormControl style={{ width: '93%', padding: '0px 10px 10px 10px' }}>
                                 <Input
                                    name="currentPassword"
                                    id="currentPassword"
                                    type="password"
                                    label="Current Password"
                                    placeholder="Current Password"
                                    showLabel
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    disabled={false}
                                    required={true}
                                    maxLength={50}
                                 />
                              </FormControl>
                           )}
                           <FormControl style={{ width: '93%', padding: '0px 10px 10px 10px' }}>
                              <Input
                                 name="newPassword"
                                 id="newPassword"
                                 type="password"
                                 label="New Password"
                                 placeholder="New Password"
                                 showLabel
                                 values={values}
                                 errors={errors}
                                 touched={touched}
                                 handleChange={handleChange}
                                 handleBlur={handleBlur}
                                 disabled={false}
                                 required={true}
                                 maxLength={50}
                              />
                           </FormControl>
                           <FormControl style={{ width: '93%', padding: '0px 10px 10px 10px' }}>
                              <Input
                                 name="confirmPassword"
                                 id="confirmPassword"
                                 type="password"
                                 label="Confirm Password"
                                 placeholder="Confirm Password"
                                 showLabel
                                 values={values}
                                 errors={errors}
                                 touched={touched}
                                 handleChange={handleChange}
                                 handleBlur={handleBlur}
                                 disabled={false}
                                 required={true}
                                 maxLength={50}
                              />
                           </FormControl>
                        </DialogContent>
                        <DialogActions style={{ padding: '20px 10px' }}>
                           <Button
                              style={{ textTransform: 'none' }}
                              size="small"
                              color="default"
                              onClick={() => {
                                 handleReset();
                                 props.setOpen(false);
                              }}
                           >
                              Cancel
                           </Button>
                           <Button
                              disabled={isSubmitting}
                              onClick={() => handleSubmit()}
                              style={{ textTransform: 'none' }}
                              size="small"
                              color="primary"
                              variant="contained"
                           >
                              {isSubmitting ? 'Saving...' : 'Change Password'}
                           </Button>
                        </DialogActions>
                     </form>
                  </Dialog>
               );
            }}
         </Formik>
      </div>
   );
};

export default ChangePasswordModal;
